import { APIDecoratorWithBaseURI } from '../../Service/api'


export const useAbandonedCart = (
  id: string | undefined,
  startAt: string,
  endAt: string,
) => {
  const useAbandonedCartFetcher = async () => {
    return await callApi(`order_sessions`)
  }

  const useAbandonedCartStatsFetcher = async () => {
    return await callApi(`order_sessions/stats`)
  }

  const callApi = async (url: string) => {
    try {
      let params: any = {
        eventId: id,
      }

      if (startAt && endAt) {
        params = {
          ...params,
          startAt,
          endAt,
        }
      }

      return APIDecoratorWithBaseURI(process.env.REACT_APP_ABANDONED_CART_URL).post(url, params)
    } catch (error) {
      console.log(error);
    }
  }

  return {
    useAbandonedCartFetcher,
    useAbandonedCartStatsFetcher
  }
}
